/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-05 13:56:13
 * @LastEditTime: 2020-08-05 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/store/modules/template.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getTemplateDataApi,
  createTemplate,
  getTemplateInfo,
  editTemplate,
  deleteTemplate
} from "@/service/templateService";

const template = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    /**
     * 获取模板列表
     * @param {*} store
     * @param {*} info 请求参数
     */
    getTemplateDataApi(store, info) {
      return new Promise((resolve, reject) => {
        getTemplateDataApi(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 创建模板
     * @param {*} store
     * @param {*} data
     */
    createTemplate(store, data) {
      return new Promise((resolve, reject) => {
        createTemplate(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取模板详情
     * @param {*} store
     * @param {*} id
     */
    getTemplateInfo(store, id) {
      return new Promise((resolve, reject) => {
        getTemplateInfo(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 编辑模板
     * @param {*} store
     * @param {*} data
     */
    editTemplate(store, data) {
      return new Promise((resolve, reject) => {
        editTemplate(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除模板
     * @param {*} store
     * @param {*} id
     */
    deleteTemplate(store, id) {
      return new Promise((resolve, reject) => {
        deleteTemplate(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default template;



// WEBPACK FOOTER //
// ./src/store/modules/template.js